import { render } from "./view-opinion-small.vue?vue&type=template&id=e215608a&scoped=true&lang=html"
import script from "./view-opinion-small.vue?vue&type=script&lang=js"
export * from "./view-opinion-small.vue?vue&type=script&lang=js"

import "./view-opinion-small.vue?vue&type=style&index=0&id=e215608a&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e215608a"]])

export default __exports__